import React from 'react';
import PropTypes from 'prop-types';
import Hero from 'components/hero';
import FancyButton from 'components/fancy-button';

const SignUp = ({ userType }) => {
  return (
    <Hero layout="vertical" className="bg-dark-blue">
      <h1 className="text-center">Sign up with MyShifts today</h1>
      <p className="text-center">
        MyShifts enables workers and employers to &apos;connect&apos; with each
        other in a direct way.
      </p>
      <FancyButton type="secondary" href={`./workers-warning`}>
        Sign up Now
      </FancyButton>
    </Hero>
  );
};

SignUp.propTypes = {
  userType: PropTypes.string.isRequired,
};

export default SignUp;
